import { IMeshColumnData } from "@pageBuilder/typings";
import { DomUtil } from "src/utils/dom-util";
import { MeshInteractionChecker } from "../mesh-interaction-checker";
import { CascadeDataCleanUpService } from "src/services/cascade-data-cleanup.service";

export class MeshColumnRenderer {

    public createNew(id?: string): HTMLElement {
        const column = document.createElement("div");
        column.setAttribute("data-mesh-col", "");

        if (!column.id) {
            column.id = id ?? DomUtil.generateElementId();
        }

        return column;
    }

    public render(column: HTMLElement, data: IMeshColumnData | undefined): void {
        if (!data) {
            return;
        }

        if (!data.size) { data.size = 1; }

        const cleanData = CascadeDataCleanUpService.cleanUp(data);
        column.setAttribute("data-element-json", JSON.stringify(cleanData));

        column.classList.remove("col-1", "col-2", "col-3", "col-4", "col-5", "col-6", "col-7", "col-8", "col-9", "col-10", "col-11", "col-12");

        column.setAttribute("data-col-size", data.size.toString());
        column.classList.add("col", `col-${data.size}`, "empty");

        column.classList.toggle("empty", data.isEmpty);
        column.classList.toggle("add-l-disabled", !MeshInteractionChecker.checkAddWidgetAbility(column, "Left"));
        column.classList.toggle("add-r-disabled", !MeshInteractionChecker.checkAddWidgetAbility(column, "Right"));
        column.classList.toggle("drag-l-disabled", !MeshInteractionChecker.checkDragWidgetAbility(column, "Left"));
        column.classList.toggle("drag-r-disabled", !MeshInteractionChecker.checkDragWidgetAbility(column, "Right"));

        column.style.setProperty("--data-col-size", data.size.toString());
    }

    public getData(column: HTMLElement): IMeshColumnData {
        const parsedData = JSON.parse(column.getAttribute("data-element-json")!) as IMeshColumnData;
        return CascadeDataCleanUpService.cleanUp(parsedData);
    }

}
